import TileBanner from './TileBanner'

export default TileBanner
// eslint-disable-next-line import/export
export * from './TileBanner'
